module.exports = __webpack_public_path__ + "img/icon.739ff85d.png";